import { TextareaHTMLAttributes, RefObject } from 'react'
import clsx from 'clsx'
import $form from '@tandem/ui/form.css'

export interface TextareaInputProps
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'value' | 'onChange' | 'onBlur'> {
  field: any
  onValueChange?: (value: string) => void
  ref?: RefObject<HTMLTextAreaElement | null>
}

export default function TextareaInput({ field, onValueChange, ...props }: TextareaInputProps) {
  return (
    <textarea
      {...props}
      value={field.state.value ?? ''}
      onChange={(e) => {
        field.handleChange(e.target.value)
        onValueChange?.(e.target.value)
      }}
      onBlur={field.handleBlur}
      class={clsx(props.class, {
        [$form.error]: !field.state.meta.isValid && field.state.meta.isTouched,
      })}
      placeholder={props.placeholder ?? ' '}
    />
  )
}
